import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Wrapper, Icon, Content } from './styles';
import Utils from '../../../../../../utils';
import useClickOutside from '../../../../../../utils/customHooks/useClickOutside';

interface TooltipProps {
	message: string;
}

const Tooltip = ({ message }: TooltipProps) => {
	const wrapperElement = React.useRef<HTMLDivElement>(null);
	const [isDisplayed, setIsDisplayed] = React.useState(false);
	useClickOutside(wrapperElement, isDisplayed, () => setIsDisplayed(false));

	return (
		<Wrapper ref={wrapperElement}>
			<Icon
				onClick={() => setIsDisplayed(prevState => !prevState)}
			>
				{Utils.getSvgIcon('iconset_uprez_info2')}
			</Icon>
			{isDisplayed &&
				<Content>
					<Translate value={message} />
				</Content>
			}
		</Wrapper>
	);
};

export default Tooltip;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SpreadBackgroundPanel/MediaPreview/Tooltip/index.tsx